import { AppLayout } from '@/layouts/app/app-layout';

export default function Impressum() {
    return (
        <AppLayout title="Impressum">
            <section className="container mx-auto mt-32">
                <div className="prose prose-invert max-w-none px-4 xl:px-0">
                    <h1>Impressum</h1>

                    <p>
                        HM Harmonie Media GmbH
                        <br />
                        Wilhelmstraße 30
                        <br />
                        64354 Reinheim
                    </p>

                    <p>
                        Handelsregister: HRB 107340
                        <br />
                        Registergericht: Darmstadt
                    </p>

                    <h2>Geschäftsführer</h2>
                    <p>
                        Philipp Knoll
                        <br />
                        Benjamin Geißler
                    </p>

                    <h2>Kontakt</h2>
                    <p>E-Mail: info@harmoniemedia.de</p>

                    <h2>Umsatzsteuer-ID</h2>
                    <p>
                        Umsatzsteuer-Identifikationsnummer gemäß § 27 a Umsatzsteuergesetz:
                        <br />
                        DE111637275
                    </p>

                    <h2>EU-Streitschlichtung</h2>
                    <p>
                        Die Europäische Kommission stellt eine Plattform zur Online-Streitbeilegung (OS) bereit:{' '}
                        <a href="https://ec.europa.eu/consumers/odr/" target="_blank" rel="noopener noreferrer">
                            https://ec.europa.eu/consumers/odr/
                        </a>
                        .<br /> Unsere E-Mail-Adresse finden Sie oben im Impressum.
                    </p>

                    <h2>Verbraucherstreitbeilegung/Universalschlichtungsstelle</h2>
                    <p>Wir sind nicht bereit oder verpflichtet, an Streitbeilegungsverfahren vor einer Verbraucherschlichtungsstelle teilzunehmen.</p>
                </div>
            </section>
        </AppLayout>
    );
}
